var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"header-notice",on:{"click":_vm.fetchNotice}},[_c('a-badge',{attrs:{"count":_vm.msgCount}},[_c('a-icon',{staticStyle:{"font-size":"16px","padding":"4px"},attrs:{"type":"bell"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }